export default __webpack_public_path__ + "static/media/logo.cc1277f2.png";